import { render, staticRenderFns } from "./AdminCompanyLayout.vue?vue&type=template&id=634e3e01&scoped=true&"
import script from "./AdminCompanyLayout.vue?vue&type=script&lang=js&"
export * from "./AdminCompanyLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdminCompanyLayout.vue?vue&type=style&index=0&id=634e3e01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634e3e01",
  null
  
)

export default component.exports